import { ContentInfoPanel } from "@dropbox/dash-component-library";
import { Box } from "@dropbox/dig-foundations";
import type { TypeaheadResult } from "@mirage/mosaics/SearchBarWithTypeahead/useConvertToTypeaheadResults";
import { useTheme } from "@mirage/service-settings/theming/useTheme";
import { getTypeaheadResultInfo } from "./getTypeaheadResultInfo";

export const TypeaheadInfoPanel = ({
  result,
  query,
}: {
  result: TypeaheadResult;
  query: string;
}) => {
  const isDarkMode = useTheme();
  const resultInfo = getTypeaheadResultInfo(result, query, isDarkMode);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // Prevent all clicks on this Box and its children from taking focus from search input
    e.preventDefault();
  };

  return (
    <Box
      width="100%"
      height="100%"
      borderTop="Solid"
      borderLeft="Solid"
      borderColor="Border Subtle"
      borderWidth="1"
      onMouseDown={handleClick}
    >
      <ContentInfoPanel {...resultInfo} />
    </Box>
  );
};
